<template>
  <div class="order">
    <div class="p-title">H5素材编辑器</div>
    <div class="p-main">
      <div style="height: 100%;">
        <div class="list_search clearfix">
          <ListSearchCp
            class="left_box"
            v-model="searchOpt"
            @change="data => { searchOpt = data; getList(1); }">
          </ListSearchCp>
          <el-button type="primary" class="add_button" @click="addH5">新增</el-button>
        </div>
        <div class="order-list">
          <ListTable :data="tableData" @deleteRow="deleteRow"></ListTable>
          <Pagination
            class="page_box"
            :total="pageInfo.total"
            :current-page.sync="pageInfo.current"
            :size.sync="pageInfo.size"
            @fn-change="getList">
          </Pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import ListTable from './ListTable.vue'
import ListSearchCp from './ListSearchCp.vue'

export default {
  name: 'H5Edit',
  components: { Pagination, ListTable, ListSearchCp },
  data () {
    return {
      tableData: [],
      pageInfo: {
        total: 0,
        current: 1,
        size: 20
      },
      searchOpt: {}
    }
  },
  computed: {
    cusId () {
      return this.$store.state.customer.userInfo.customerId
    }
  },
  watch: {
    cusId (n, o) {
      this.getList(1)
    }
  },
  methods: {
    async getList (p) {
      if (!this.cusId) return
      if (p && typeof p == 'number') this.pageInfo.current = p
      this.tableData = []
      let param = {
        ...this.searchOpt,
        clienteleGuid: this.cusId,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size,
      }
      let loading = this.$loading()
      let response = await this.fetch('/design/web/material/v2/queryMaterialPageInfo', param, 'POST')
      loading.close()
      if (response.data) {
        this.tableData = response.data.list || []
        this.pageInfo.total = response.data.total || 0
      }
    },
    async setCurrentDetail (row, type) {
      this.currentRow = {
        ...row
      }
      if (type == 'showUpload') {
        this.currentRow.advContentDto = await this.getOldResource(this.currentRow)
      }
      this.$set(this.currentRow, type, true)
    },
    addH5 () {
      this.$router.push({
        name: 'H5Add'
      })
    },
    async deleteRow (row) {
      this.$confirm('此操作将永久删除该H5, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await this.fetch('/design/web/material/v2/delMaterial?materiaGuid=' + row.materiaGuid, null, 'GET')
        if (response.code === 0) {
          this.$message.success(response.message)
          this.getList()
        } else {
          this.$message.error(response.message)
        }
      }).catch(() => {
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.order-list {
  padding: 20px 20px 62px;
  border: 1px solid #e9e9e9;
  height: calc(100% - 65px);
  position: relative;
  min-width: 900px;
  ::v-deep .el-table {
    border-top: none;
    height: 100%;
    .el-table__header {
      background: #F1F1F1;
      .cell {
        border-right: 1px solid #D4D4D4;
        color: #282729;
        height: 24px;
        line-height: 24px
      }
      .is-leaf {
        border-right: none;
        background: #F1F1F1
      }
    }
    .el-table__row {
      td {
        padding: 10px 0
      }
    }
  }
  .page_box {
    height: 60px;
    padding: 6px 10px;
    border-left: 1px solid #E9E9E9;
    border-right: 1px solid #E9E9E9
  }
}
.row_order {
  text-align: left;
  p {
    line-height: 1;
    margin-top: 10px;
    padding-left: 20px
  }
  .order_no {
    background: rgba(255, 57, 115, 0.1);
    line-height: 30px;
    color: #282729;
    padding-left: 20px;
    .time {
      display: inline-block;
      margin-right: 20px
    }
  }
  .time {
    color: #282729;
    font-weight: 600
  }
  .color_999 {
    color: #999;
    font-size: 12px
  }
  .area {
    line-height: 1.5;
    color: #282729
  }
}
.order {
  .p-main {
    padding: 0
  }
}
.list_search {
  padding: 15px 20px;
  background: #F5F5F5;
  .left_box {
    float: left;
    width: calc(100% - 110px);
  }
  .add_button {
    float: right;
    width: 100px;
    height: 40px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
  }
}
.order-list {
  ::v-deep .el-table--mini, .el-table--small, .el-table__expand-icon {
    thead {
      font-size: 14px;
    }
  }
}


</style>
